import axios from 'axios';
import { useEffect } from 'react';
import { API_PREFIX } from '@app/config';
import { OTHER_APP_HEADER, goToOtherApp } from '@app/core/utilities/getOtherAppUrl';

axios.defaults.baseURL = API_PREFIX;

// Running beside the new app: when the API says the current company is served by the other app, go there (the API only
// says so when Coexistence:NewAppUrl is set). Installed here rather than in the effect below because route loaders
// call the API before this provider mounts.
axios.interceptors.response.use(
  (response) => {
    const otherApp = response.headers?.[OTHER_APP_HEADER] as string | undefined;
    return otherApp ? goToOtherApp(otherApp, response.config.url) : response;
  },
  (error) => {
    const otherApp =
      axios.isAxiosError(error) && error.response?.status === 409
        ? (error.response.headers?.[OTHER_APP_HEADER] as string | undefined)
        : undefined;
    return otherApp ? goToOtherApp(otherApp, error.config?.url) : Promise.reject(error);
  }
);

interface IProps {
  children: React.ReactNode;
}
export const AxiosConfigProvider = (props: IProps) => {
  const { children } = props;

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          return window.location.reload();
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return children;
};
